
import Vue from 'vue';
import App from './App.vue';
import router from './router';

import NowUiKit from './plugins/now-ui-kit';
import VueParticles from 'vue-particles';
import VueScrollTo from 'vue-scrollto';
import VueScrollactive from 'vue-scrollactive';
import VueHead from 'vue-head';

Vue.config.productionTip = false;

Vue.use(VueHead, {
  separator: '|',
  complement: 'Proyectos SEES'
})
Vue.use(NowUiKit);
Vue.use(VueParticles);
Vue.use(VueScrollTo);
Vue.use(VueScrollactive);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
